<ng-container>
  @if (this.display() === 'both' || this.display() === 'label') {
    {{ (this.label$ | async) || '' | translate }}
  }
  @if (this.display() === 'both' || this.display() === 'amount') {
    {{ this.amount$ | async | currency }}
  }
</ng-container>
